export const getFormData = (file: any, site: string, path: string, fileExistCheck: boolean) => {
  const formData = new FormData();
  formData.append('filedata', file, file.name);
  formData.append('filename', file.name);
  formData.append('siteId', site);
  formData.append('containerId', 'documentLibrary');
  formData.append('uploaddirectory', path || '');
  formData.append('createdirectory', true);
  formData.append('majorVersion', false);
  formData.append('overwrite', false);
  formData.append('thumbnails', 'doclib');
  formData.append('updatenameandmimetype', false);
  if (fileExistCheck) {
    formData.append('fileexistcheck', true);
  }
  return formData;
};

export const getNewVersionFormData = (file: any, nodeRef: string, desc: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('nodeRef', nodeRef);
  formData.append('desc', desc);

  return formData;
};

export const getFile = async (fileEntry: any, fileError: any) => {
  try {
    return await new Promise((resolve, reject) => fileEntry.file(resolve, reject));
  } catch (err) {
    console.error(fileEntry);
    fileError.push(fileEntry?.name || "");
  }
};

export const getErrorMessage = (error: string) => {
  if (error.includes('file exists')) return window.Alfresco.messages.global['edocat.upload.name-error'];
  if (error.includes('555edcQ')) return error.split(' ').slice(2).join(' ');
  return window.Alfresco.messages.global['edocat.upload.error'];
};

export const getErrorIndices = (files: any[]) =>
  files.reduce((acc, next, index) => {
    if (next.error && next.error.includes('file exists')) {
      acc.push(index);
    }
    return acc;
  }, []);
